export const DATE_FORMAT_RO = "DD.MM.YYYY";
export const DATE_TIME_FORMAT_RO = "DD.MM.YYYY HH:mm:ss";
export const DATE_FORMAT_ISO = "YYYY-MM-DD";
export const DATE_TIME_FORMAT_ISO = "YYYY-MM-DDTHH:mm:ss.SSS[Z]";
export const DATE_TIME_FORMAT_ISO_SHORT = "YYYY-MM-DDTHH:mm:ss";

export const PATTERN_EMAIL_ADDRESS = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
export const PATTERN_PHONE_NUMBER = /^\+?\d{1,4}?[-.\s]?\(?\d{1,3}?\)?[-.\s]?\d{1,4}[-.\s]?\d{1,4}[-.\s]?\d{1,9}$/;
export const PATTERN_COGNITO_PASSWORD = /^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[\^$*.[\]{}()?"!@#%&/\\,><':;|_~`=+\- ])[A-Za-z0-9^$*.[\]{}()?"!@#%&/\\,><':;|_~`=+\- ]{8,256}$/;
export const PATTERN_INTEGER = /^[0-9]+$/;